import { OpenAPI } from '../services';

OpenAPI.TOKEN = process.env.REACT_APP_API_KEY;
const apiUrl = process.env.REACT_APP_API_URL;

if (process.env.NODE_ENV === 'development' || !apiUrl || apiUrl === 'null') {
  OpenAPI.BASE = '/api';
} else {
  OpenAPI.BASE = apiUrl;
}

export * from './quiz';
export * from './courses';

export const getUserOrgs = async () => {
  // return UserApiService.getAffiliatedOrganizations();
  return { organizations: [] } as any;
};

// TODO: DELETE
export type UserRoleDto = {
  id?: string;
  name?: string;
  permissions?: Array<string>;
};

export type UserOrganizationDto = {
  id?: string;
  name?: string;
  roles?: Array<UserRoleDto>;
};
